import { useTranslation } from 'react-i18next'

import facebookImage from 'assets/images/facebook.png'

import styles from './AuthorizationLogin.module.scss'

const FacebookLogin = () => {
  const { t } = useTranslation('connections')
  return (
    <div className={styles.facebook}>
      <img src={facebookImage} />
      <span>{t('setup.authorization.facebook.signIn')}</span>
    </div>
  )
}
export default FacebookLogin
